import * as React from 'react';
import { errorMessages } from 'utils/MobxDataManager/singletons';
import { NavigationErrors } from 'typings/enums';
import './errorDisplayView.scss';

export default class ErrorDisplayView extends React.Component {

    render(): React.ReactNode {
        const takeActionMessage = errorMessages.errorMessage === NavigationErrors.NoReports ?
            'Please reach out to your HR team to resolve this issue.' :
            'Please contact cs@payscale.com to resolve this issue.';
        return (
            <div className="nomst-error-display-view">
                <div className="nomst-error-display-view__body">
                    <h2 className="nomst-error-display-view__header">
                        {errorMessages.errorMessage}
                    </h2>
                    <div className="nomst-error-display-view__sub-header">
                        {takeActionMessage}
                    </div>
                </div>
            </div>
        );
    }
}